export const Routes = {
  API_HOSTNAME: "https://www.portal.measervices.in",
  WEBSOCKET_HOSTNAME: "wss://www.portal.measervices.in:8081",

  // API_HOSTNAME: "http://192.168.1.87:8082",
  // WEBSOCKET_HOSTNAME: "ws://192.168.1.87:8082",

  API_HOSTNAME_WP: "https://api.wapmonkey.com",
  INSERTLEAD: "insert-lead",
  GETUSERBYID: "get-userbyid",
};
